import React from 'react';
import CustomButton from './CustomButton';
import { useNavigate } from 'react-router-dom'
import './HeroSectionParceiros.css';

const HeroSectionParceiros = () => {
  const navigate = useNavigate()

  return (
    <section className="hero-parceiros-section">
      <div className="hero-parceiros-content">
        <div className="hero-parceiros-text">
          <h1 className="hero-parceiros-title">
            Nós levamos os clientes até você.
          </h1>
          <p className="hero-parceiros-subtitle">
            Com o Clube do Banho, você não precisa se preocupar com anúncios nem prospecção. Nós buscamos os tutores — você só precisa atendê-los bem e vender mais durante o banho.
          </p>
          <div className="hero-parceiros-button">
            <CustomButton
              variant="contained"
              sx={{
                backgroundColor: '#FF914D',
                color: '#FFFFFF',
                padding: '14px 32px',
                '&:hover': {
                  backgroundColor: '#e67e3d',
                },
              }}
              onClick={() => navigate('/cadastro-parceiro')}
            >
              Cadastre seu negócio
            </CustomButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionParceiros;

